import type { RequestFn } from '../../client';

export class Configs {
  constructor(private readonly request: RequestFn) {}

  /** Create a config. `POST /configs` */
  async create(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/configs', { body: params });
  }

  /** Retrieve a config by key. `GET /configs/{key}` */
  async retrieve(key: string): Promise<Record<string, unknown>> {
    return this.request('GET', `/configs/${encodeURIComponent(key)}`);
  }

  /** Update a config. `PUT /configs/{key}` */
  async update(key: string, params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('PUT', `/configs/${encodeURIComponent(key)}`, { body: params });
  }

  /** Delete a config. `DELETE /configs/{key}` */
  async delete(key: string): Promise<Record<string, unknown>> {
    return this.request('DELETE', `/configs/${encodeURIComponent(key)}`);
  }
}
